/**
 * Check if any required platform attributes are missing or invalid.
 * Used by parent forms to control save button disabled state.
 */
export function hasMissingRequiredPlatformAttributes(
  platformAttributes,
  platformAttributeValues,
) {
  if (!platformAttributes) return false;
  return platformAttributes.some((attr) => {
    const validation = attr.config?.validation;
    if (!validation?.required) return false;
    const value = platformAttributeValues?.[attr.name] || "";
    if (!value) return true;
    if (validation.min && value.length < validation.min) return true;
    return false;
  });
}
